import axios from 'axios';

if (!process.env.AUTH_API_URL) {
  throw new Error('required env var AUTH_API_URL is not defined');
}
const authApi = axios.create({baseURL: process.env.AUTH_API_URL});

const setAuthorizationHeader = (jwt) => {
  authApi.defaults.headers.common['Authorization'] = jwt ? `Bearer ${jwt}` : '';
};

const postEmailVerified = (jwt) => {
  setAuthorizationHeader(jwt);
  return authApi.post('/auto-verify');
};

const getRemoteAuth = (hostUrl, jwt) => {
  setAuthorizationHeader(jwt);
  return authApi.get('/remote-authentication', {params: {hostUrl}});
};

const postVerificationEmail = (jwt, redirectUrl) => {
  setAuthorizationHeader(jwt);
  return authApi.post('/send-verification-email', {redirectUrl});
};

const postResetPassword = (email, redirectUrl) => {
  return authApi.post('/send-reset-password-email', {email, redirectUrl});
};

export {postEmailVerified, getRemoteAuth, postVerificationEmail, postResetPassword};
